export default __webpack_public_path__ + "static/media/hbs-bpk-2.21665c48.png";